(function () {
  function wire(stage) {
    if (!stage || stage.dataset.ondeSwitchReady === '1') return;
    stage.dataset.ondeSwitchReady = '1';

    var section = stage.closest('.onde-switch');
    if (!section) return;
    var btn = section.querySelector('[data-onde-switch-btn]');
    var label = section.querySelector('[data-onde-switch-label]');
    if (!btn) return;

    if (stage.querySelector('.onde-switch__shot--on')) stage.classList.add('has-lit');

    var off = stage.dataset.labelOff || 'Off';
    var on = stage.dataset.labelOn || 'On';

    function apply(lit) {
      stage.classList.toggle('is-on', lit);
      btn.setAttribute('aria-checked', lit ? 'true' : 'false');
      if (label) label.textContent = lit ? on : off;
    }

    btn.addEventListener('click', function () {
      apply(btn.getAttribute('aria-checked') !== 'true');
    });

    apply(false);
  }

  function init(root) {
    (root || document).querySelectorAll('[data-onde-switch]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
